var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerSabotageCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68283 14.5152L5.98089 18.3496L5.89672 12.9305L0.504678 13.5819L4.27117 9.66681L0 6.31972L5.41917 6.23555L4.76774 0.843506L8.68283 4.60999V7.2965L7.13789 5.59356L7.43134 7.9806L5.03676 8.02512L6.91257 9.47929L5.25473 11.2118L7.64177 10.9183L7.68629 13.3129L8.68283 11.984V14.5152ZM10.3532 15.0628C10.7449 15.4544 11.2157 15.6503 11.7657 15.6503H20.7657C21.3157 15.6503 21.7866 15.4544 22.1782 15.0628C22.5699 14.6711 22.7657 14.2003 22.7657 13.6503V11.1503L26.7657 15.1503V4.15026L22.7657 8.15026V5.65026C22.7657 5.10026 22.5699 4.62942 22.1782 4.23776C21.7866 3.84609 21.3157 3.65026 20.7657 3.65026H11.7657C11.2157 3.65026 10.7449 3.84609 10.3532 4.23776C9.96157 4.62942 9.76574 5.10026 9.76574 5.65026V13.6503C9.76574 14.2003 9.96157 14.6711 10.3532 15.0628ZM20.7657 13.6503H11.7657V5.65026H20.7657V13.6503Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerSabotageCamera);
export default __webpack_public_path__ + "static/media/tower_sabotage_camera.0dcc8ac6bc990693e29d589f90a12b9e.svg";
export { ForwardRef as ReactComponent };